var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs uppercase p-1 rounded font-bold",class:_vm.bgClass},[_c('span',{class:_vm.statusClass},[_vm._v(_vm._s(_vm.statusName))])])}
var staticRenderFns = []

export { render, staticRenderFns }